<template>
  <a-card :bordered="false" :headStyle="{ fontSize: '18px' }">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['search_orderNo', 'search_date']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="orderNo"
      :leftSpace="20"
      :requestPromise="loadPromise"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
    >
      <!-- getCheckboxProps: propRules -->
      <a-form-item slot="search_orderNo" label="订单编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_date" label="订单日期" v-bind="searchItemLayout">
        <a-range-picker style="width: 100%;" format="YYYY-MM-DD" @change="onChange"/>
      </a-form-item>
      <a-form-item slot="operation">
        <a-button type="primary" @click="showModal">申请发票</a-button>
      </a-form-item>
    </search-page-view>
    <a-modal
      title="发票详情"
      :visible="visible"
      :width="670"
      :afterClose="handleClose"
      @cancel="handleCancel"
      :footer="null"
    >
      <div style="font-size: 18px;margin-left:35px">
        <span>发票开具总金额：</span>
        <span style="color: #f25001;">{{ ruleForm.invoiceAmount }}</span
        >元
      </div>
      <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="发票抬头" prop="invoiceHeader">
          <a-input v-model="ruleForm.invoiceHeader" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="抬头类型" prop="headerType">
          <a-radio-group v-model="ruleForm.headerType">
            <a-radio :value="1">
              企业
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="发票类型" prop="invoiceType">
          <a-radio-group style="white-space:nowrap" v-model="ruleForm.invoiceType">
            <a-radio value="1" v-if="invoiceType1">
              增值税电子普通发票
            </a-radio>
            <a-radio value="2" v-if="invoiceType2">
              增值税纸质普通发票
            </a-radio>
            <a-radio value="3" v-if="invoiceType3">
              增值税纸质专用发票
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="纳税人识别号" prop="taxpayerIdentificationNumber">
          <a-input v-model="ruleForm.taxpayerIdentificationNumber" placeholder="请输入纳税人识别号"/>
        </a-form-model-item>
        <a-form-model-item label="收票人姓名" prop="receiveInvoiceName">
          <a-input v-model="ruleForm.receiveInvoiceName" placeholder="请输入收票人姓名"/>
        </a-form-model-item>
        <a-form-model-item label="收票人电话" prop="receiveInvoiceMobile">
          <a-input v-model="ruleForm.receiveInvoiceMobile" placeholder="请输入收票人电话"/>
        </a-form-model-item>
        <a-form-model-item
          v-if="ruleForm.invoiceType == 2 || ruleForm.invoiceType == 3"
          label="收票地址"
          prop="receiveInvoiceLinkContent1"
        >
          <a-input v-model="ruleForm.receiveInvoiceLinkContent1" placeholder="收票地址"/>
        </a-form-model-item>
        <a-form-model-item v-else label="收票人邮箱" prop="receiveInvoiceLinkContent">
          <a-input v-model="ruleForm.receiveInvoiceLinkContent" placeholder="请输入收票人邮箱"/>
        </a-form-model-item>
        <a-form-model-item label="备注信息" prop="remark">
          <a-input v-model="ruleForm.remark" placeholder="如需要明细开票或科目开票请特别说明"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="onSubmit">提交申请</a-button>
          <a-button style="margin-left: 5%;" @click="visible = false">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'
import userHelper from '../../../utils/helper/userHelper'
import { mapActions } from 'vuex'

export default {
  name: 'InvoiceOrder',
  mixins: [searchForm],
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      ruleForm: {
        headerType: 1,
        remark: '',
        orderList: [],
        invoiceType: '',
        invoiceHeader: '',
        taxpayerIdentificationNumber: '',
        receiveInvoiceName: '',
        receiveInvoiceMobile: '',
        receiveInvoiceLinkContent1: '',
        receiveInvoiceLinkContent: ''
      },
      queryParams: {},
      selectedRowKeys: [],
      selectedStr: '',
      selected: 1,
      invoiceType: [],
      loadPromise: params => this.getDataList(params),
      visible: false,
      rules: {
        headerType: [
          {
            required: true,
            message: '请选择抬头类型',
            trigger: 'blur'
          }
        ],
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'blur' }],
        invoiceHeader: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
        taxpayerIdentificationNumber: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
        receiveInvoiceName: [{ required: true, message: '请输入收票人姓名', trigger: 'blur' }],
        receiveInvoiceMobile: [
          { required: true, message: '请输入收票人电话', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号！', trigger: 'blur' }
        ],
        receiveInvoiceLinkContent1: [{ required: true, message: '请输入收票地址', trigger: 'blur' }],
        receiveInvoiceLinkContent: [
          { required: true, message: '请输入收票人邮箱', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/,
            message: '邮箱格式不正确',
            trigger: 'blur'
          }
        ]
      },
      invoiceType1: false,
      invoiceType2: false,
      invoiceType3: false,
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '商品信息',
          dataIndex: 'productMsg',
          width: '40%'
        },
        {
          title: '金额',
          dataIndex: 'orderAmount'
        },
        {
          title: '支持发票类型',
          dataIndex: 'invoiceType'
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: '80px'
        }
      ],
      proMerchantId: '',
      proInvoiceType: '',
      selectedRows: [],
      isShow: true
    }
  },
  mounted() {
    this.getCloudCode()
    this.invoiceType = this.getAppConstants().getInvoiceType()
  },
  methods: {
    ...mapActions(['GetCloudToken']),
    //获取云仓token
    getCloudCode() {
      const userInfo = this.$store.getters.userInfo
      let merchantId = userInfo.merchantId
      const childAccountId = userInfo.account && userInfo.account > 3 ? userInfo.account : 0
      let platformId = this.getPlatformConfig().platformId
      let validationKey = userHelper.getCloudMD5Code(String(merchantId), String(platformId))
      let parmas = {
        merchantOppId: merchantId,
        platformId: platformId,
        validationKey: validationKey,
        childAccountId: childAccountId
      }
      this.GetCloudToken(parmas).then(res => {
        this.isSuccess = 1
      })
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.ruleForm.invoiceType !== 1) {
            if (this.ruleForm.receiveInvoiceLinkContent1) {
              this.ruleForm.receiveInvoiceLinkContent = this.ruleForm.receiveInvoiceLinkContent1
            }
          }
          delete this.ruleForm.receiveInvoiceLinkContent1
          this.getHttpServices()
            .getCloudUserService()
            .post('invoice/v2/saveInvoice', this.ruleForm)
            .then(res => {
              this.$message.success('提交成功')
              this.$refs.ruleForm.resetFields()
              this.visible = false
              this.selectedRowKeys = []
              this.selectedRows = []
              this.$refs.pageList.refresh(true)
            })
            .catch(err => {
              this.$message.error(err.msg)
            })
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },

    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.invoiceType1 = false
      this.invoiceType2 = false
      this.invoiceType3 = false
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ruleForm.orderList = selectedRowKeys
      let amount = 0
      if (selectedRows.length > 0) {
        let firstMerchantID = selectedRows[0].orderProMerchantId
        let firstInvoiceType = selectedRows[0].invoiceType
        let flag = true
        selectedRows.forEach((item, index) => {
          amount += item.orderAmount
          if (firstMerchantID == item.orderProMerchantId && firstInvoiceType == item.invoiceType) {
            flag = true
            this.isShow = true
          } else {
            flag = false
            this.isShow = false
          }
        })
        if (!flag) {
          this.$message.error('请选择支持发票类型且商户类型相同的订单！')
        }
        var str = selectedRows[0].invoiceType
        var reg1 = RegExp(/增值税电子普通发票/)
        var reg2 = RegExp(/增值税纸质普通发票/)
        var reg3 = RegExp(/增值税纸质专用发票/)
        if (reg1.test(str)) {
          this.invoiceType1 = true
        }
        if (reg2.test(str)) {
          this.invoiceType2 = true
        }
        if (reg3.test(str)) {
          this.invoiceType3 = true
        }
      }
      this.ruleForm.invoiceAmount = amount.toFixed(2)
    },
    showModal() {
      this.getLogUtils().logWithTag('this.show', this.isShow)
      if (this.isShow) {
        if (this.selectedRows.length > 0 && this.ruleForm.orderList.length > 0) {
          this.visible = true
        } else {
          this.$message.error('请至少选择一个订单')
        }
      } else {
        this.$message.error('请选择支持发票类型且商户类型相同的订单再进行提交')
      }
    },
    handleCancel(e) {
      this.visible = false
    },
    // 获取表格数据接口
    getDataList(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      this.params = params
      return this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/getInvoiceOrderList', params)
    },
    //搜索
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    //日期传参
    onChange(value, dateString) {
      this.queryParams.orderCreateStartTime = dateString[0]
      this.queryParams.orderCreateEndTime = dateString[1]
    }
  }
}
</script>

<style scoped>
</style>